import { PlatformProvider } from './platform';
import { FeatureFlagsProvider, DevMenu } from './feature-flags';
import { Router } from './Router';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import ErrorView from './views/ErrorView';
import Main from './components/Main/Main';
import './App.css';

function App(): React.ReactNode {
  return (
    <PlatformProvider>
      <FeatureFlagsProvider>
        <ErrorBoundary
          fallback={
            <Main showCancelLink={false}>
              <ErrorView />
            </Main>
          }
        >
          <Router />
        </ErrorBoundary>
        <DevMenu />
      </FeatureFlagsProvider>
    </PlatformProvider>
  );
}

export default App;
